import styled, { css } from 'styled-components';
import { px2rem } from '../../../stylesheets/tools';

const StyledTagFilterResults = styled.div`
  .tag-filter-results__loading {
    margin-top: ${px2rem('125px')};
    height: 300vh;
    display: flex;
    justify-content: center;
  }

  .tag-filter-results__no-results {
    margin: 0 auto;
    margin-top: ${px2rem('125px')};
    max-width: 700px;
  }

  @keyframes slideIn {
    0% {
      opacity: 0;
      transform: translateY(100px);
    }

    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }

  ${props =>
    props.isVisible &&
    css`
      animation: slideIn 0.4s ease-in-out forwards;
    `}
`;

export default StyledTagFilterResults;
